export default __webpack_public_path__ + "static/media/sec1_mob_cats.3e72953d.png";